module.exports = __webpack_public_path__ + "img/mes-capture-order.df325eb5.png";